/**
 * useBreadcrumbs Hook
 *
 * Returns breadcrumb trail for the current route.
 */

import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { generateBreadcrumbsWithIcons } from '@/modules/utils/breadcrumbs';
import type { BreadcrumbTrail } from '@/modules/types';

/**
 * Hook to get breadcrumbs for the current route.
 * Returns a trail from Home to the current page.
 */
export function useBreadcrumbs(): BreadcrumbTrail {
  const location = useLocation();
  const { t } = useTranslation();

  return useMemo(() => {
    return generateBreadcrumbsWithIcons(location.pathname, t);
  }, [location.pathname, t]);
}

/**
 * Hook to check if we're on the home page (single breadcrumb).
 */
export function useIsHomePage(): boolean {
  const breadcrumbs = useBreadcrumbs();
  return breadcrumbs.length === 1;
}

export default useBreadcrumbs;
